export default "<a\n  href=\"javascript:\"\n  id=\"ArrowTop\"\n  (click)=\"goToTop()\"\n  class=\"{{isRotated ? 'rotate' : ''}}\"></a>"